export class TicketInfo {
    success: boolean;
    reservationInfo?: ReservationInfo;
}

export class ReservationInfo {
    reservationUid?: string;
    status?: string;
    stages?: string[];
    days?: DaysInfo[];
    ticketName?: string;
    accessLevelName?: string;
}

export class DaysInfo {
    name: string;
    date: Date | string;
}

export class ParticipantStatusRequest {
    reservationUid: string;
    userUid: string;
    longitude: number;
    latitude: number;
}

export class ParticipantStatusByAdminRequest {
    reservationUid: string;
    userUid: string;
    organizatorUid: string;
}

export class DeactivateUserStatusRequest {
    reservationUid: string;
    userUid: string;
}



// WEBPACK FOOTER //
// ./src/pages/event-ticket/event-ticket.model.ts